import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

import { DeletionActionFactory, getDeletionProps } from '../../../../store/actions/deletionActions';
import { getSelectedItemEntries } from '../../../../store/selectors/getSelectedItemSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';

interface Props {
  readonly guid: string;
}

export function WebSegmentMenu({ guid }: Props) {
  const dispatch = useAppDispatch();

  const selectedEntries = useAppSelector(getSelectedItemEntries);
  const otherItemsSelected = selectedEntries.length > 1 || selectedEntries[0].item.guid !== guid;

  const deletionProps = useAppSelector(getDeletionProps);
  const deletionActionFactory = new DeletionActionFactory(selectedEntries, deletionProps);

  return (
    <SceneMenuContent>
      <SceneMenuItem
        icon={<DeleteIcon />}
        text="Delete Web"
        disabled={otherItemsSelected || !deletionActionFactory.isDeletionFeasible()} // TODO: or other things are selected
        onClick={() => {
          dispatch(deletionActionFactory.getDeletionAction());
        }}
      ></SceneMenuItem>
    </SceneMenuContent>
  );
}
